import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MousePointerClick } from "lucide-react";

// Embedded Action Framework editor: what happens when a user clicks a data point
export function ActionEditor({ config, patchConfig }) {
  const action = config.action || { type: "none" };
  const [dashboards, setDashboards] = useState([]);
  const setA = (p) => patchConfig({ action: { ...action, ...p } });
  useEffect(() => {
    if (action.type === "drill" && dashboards.length === 0) {
      api.get("/dashboards").then(({ data }) => setDashboards(data)).catch(() => {});
    }
  }, [action.type]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="pt-1 border-t border-[color:var(--glass-border)]">
      <Label className="text-xs text-[color:var(--ink-3)] flex items-center gap-1"><MousePointerClick className="w-3.5 h-3.5" />On data point click</Label>
      <Select value={action.type || "none"} onValueChange={(v) => setA({ type: v })}>
        <SelectTrigger data-testid="action-type" className="mt-1.5 bg-[color:var(--surface)]"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Do nothing</SelectItem>
          <SelectItem value="url">Open URL</SelectItem>
          <SelectItem value="webhook">Call webhook</SelectItem>
          <SelectItem value="drill">Open another dashboard</SelectItem>
        </SelectContent>
      </Select>
      {action.type === "url" && (
        <div className="mt-2">
          <Input data-testid="action-url" className="bg-[color:var(--surface)]" placeholder="https://crm.example.com/search?q={value}" value={action.url || ""} onChange={(e) => setA({ url: e.target.value })} />
          <p className="text-[10px] text-[color:var(--ink-3)] mt-1">Placeholders: {"{value} {field} {series} {data}"} — filled from the clicked point.</p>
        </div>
      )}
      {action.type === "webhook" && (
        <div className="mt-2">
          <Input data-testid="action-webhook-url" className="bg-[color:var(--surface)]" placeholder="https://hooks.example.com/notify" value={action.webhook_url || ""} onChange={(e) => setA({ webhook_url: e.target.value })} />
          <p className="text-[10px] text-[color:var(--ink-3)] mt-1">POSTs the clicked point context (field, value, series) as JSON via the server.</p>
        </div>
      )}
      {action.type === "drill" && (
        <Select value={action.target_dashboard_id || ""} onValueChange={(v) => setA({ target_dashboard_id: v })}>
          <SelectTrigger data-testid="action-target-dashboard" className="mt-2 bg-[color:var(--surface)]"><SelectValue placeholder="Pick target dashboard" /></SelectTrigger>
          <SelectContent>{dashboards.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}</SelectContent>
        </Select>
      )}
      {action.type && action.type !== "none" && (
        <p className="text-[10px] text-[color:var(--ink-3)] mt-1.5">Note: on charts with drilldown levels, the action fires at the deepest level.</p>
      )}
    </div>
  );
}
